export default __webpack_public_path__ + "static/media/background-web.3127108a.png";